/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    UPDATE_AUTHENTICATED_USER(state, user) {
        let role = user.role;
        if (user.merchant === null) {
            user.merchant = {
                status: 'active'
            }
        }
        // else {
        //     if (user.merchant.parent_id !== 0) {
        //         role = "merchant_child"
        //     }
        // }

        if (user.merchant.status !== "active") {
            role = "unverified_merchant"
        }

        localStorage.setItem('userInfo', JSON.stringify(user));
        localStorage.setItem('userRole', role);
        localStorage.setItem('loggedIn', 'true')
    },
}

